import request from "@/common/request.js";

export function listResourceCategories(data) {
  return request({
    url: "/system/labResourceCategory/list",
    method: "post",
    params: data,
  });
}

export function listResources(data) {
  return request({
    url: "/system/labResource/list",
    method: "post",
    params: data,
  });
}
